webpackJsonp([35783957827783],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _indexModule = __webpack_require__(49);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockList = function (_React$Component) {
	  _inherits(BlockList, _React$Component);
	
	  function BlockList() {
	    _classCallCheck(this, BlockList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlockList.prototype.render = function render() {
	    var items = this.props.items;
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.list },
	      items && items.map(function (item) {
	        return _react2.default.createElement(
	          "article",
	          { key: item.id, className: _indexModule2.default.item },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: item.link ? item.link : "" },
	            item.title && _react2.default.createElement(
	              "h1",
	              { className: _indexModule2.default.title },
	              item.title
	            ),
	            item.text.text && _react2.default.createElement(
	              "div",
	              { className: _indexModule2.default.text },
	              item.text.text
	            )
	          ),
	          item.linkTitle && item.link && _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _indexModule2.default.linkMargin, to: item.link },
	            item.linkTitle
	          )
	        );
	      })
	    );
	  };
	
	  return BlockList;
	}(_react2.default.Component);
	
	exports.default = BlockList;
	module.exports = exports["default"];

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"src-components-BlockList----index-module---list---19jrn","item":"src-components-BlockList----index-module---item---39Wr5","title":"src-components-BlockList----index-module---title---2z9uB src-global-styles----content---title---1yv3A","date":"src-components-BlockList----index-module---date---u5aJZ src-global-styles----content---title---1yv3A","text":"src-components-BlockList----index-module---text---1jvzK src-global-styles----content---textSerif---2B2hn","textLarge":"src-components-BlockList----index-module---textLarge---3V5NE src-global-styles----content---textSerif---2B2hn","image":"src-components-BlockList----index-module---image----p0eU","link":"src-components-BlockList----index-module---link---23WxT","linkMargin":"src-components-BlockList----index-module---linkMargin---1oR0m src-components-BlockList----index-module---link---23WxT"};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.homepageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _BlockList = __webpack_require__(205);
	
	var _BlockList2 = _interopRequireDefault(_BlockList);
	
	var _Markdown = __webpack_require__(20);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _propTypes = __webpack_require__(6);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _indexModule = __webpack_require__(315);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    var content = this.props.data.page.edges[0].node;
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          content.title
	        ),
	        _react2.default.createElement("meta", { name: "description", content: content.metaDescription }),
	        _react2.default.createElement("meta", { property: "og:title", content: content.title }),
	        _react2.default.createElement("meta", { property: "og:description", content: content.metaDescription })
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: _indexModule2.default.blitz },
	        _react2.default.createElement(
	          "h1",
	          { className: _indexModule2.default.title },
	          content.quoteTitle
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.quote },
	          content.quote.quote
	        )
	      ),
	      _react2.default.createElement(_BlockList2.default, { items: content.blocks }),
	      _react2.default.createElement(
	        "section",
	        { className: _indexModule2.default.about },
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.aboutImageContainer },
	          content.aboutImage && _react2.default.createElement("img", {
	            className: _indexModule2.default.aboutImage,
	            src: content.aboutImage.file.url + "?w=300",
	            srcSet: "\n                  " + content.aboutImage.file.url + "?w=300 300w,\n                  " + content.aboutImage.file.url + "?w=410 410w,\n                  " + content.aboutImage.file.url + "?w=615 615w,\n                  " + content.aboutImage.file.url + "?w=820 820w\n                ",
	            width: "410"
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.aboutContent },
	          content.aboutTitle && _react2.default.createElement(
	            "h1",
	            { className: _indexModule2.default.aboutTitle },
	            content.aboutTitle
	          ),
	          content.aboutText && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.aboutText, source: content.aboutText.aboutText }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _indexModule2.default.aboutLink, to: "/over/" },
	            "Meer over Robin"
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	Home.propTypes = propTypes;
	
	exports.default = Home;
	var homepageQuery = exports.homepageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"blitz":"src-pages----index-module---blitz---2Vv1H","title":"src-pages----index-module---title---2oVtp src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","quote":"src-pages----index-module---quote---2tgfE src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6 src-global-styles----content---textSerif---2B2hn","about":"src-pages----index-module---about---2YX_B src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","aboutImageContainer":"src-pages----index-module---aboutImageContainer---h6s0y","aboutImage":"src-pages----index-module---aboutImage---1WzDD","aboutContent":"src-pages----index-module---aboutContent---pcl2f","aboutTitle":"src-pages----index-module---aboutTitle---ImenG","aboutText":"src-pages----index-module---aboutText---1Y7o3","aboutLink":"src-pages----index-module---aboutLink---aUACQ"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d2825fd82a17e86f2f2f.js